import { render, staticRenderFns } from "./ReportCardGradingEdit.vue?vue&type=template&id=1baa498e"
import script from "@/controllers/custom/report_card_grading/report-card-grading-edit.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/report_card_grading/report-card-grading-edit.js?vue&type=script&lang=js&external"
import style0 from "./ReportCardGradingEdit.vue?vue&type=style&index=0&id=1baa498e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports